(function () {
  if (window.__v6rail) return;
  window.__v6rail = true;
  var ARROW = { '-1': 'M13 8H3M7 4 3 8l4 4', '1': 'M3 8h10M9 4l4 4-4 4' };
  function button(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'v6-railnav__btn';
    b.setAttribute('data-v6-step', dir);
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + ARROW[dir] + '"/></svg>';
    return b;
  }
  // Mobile swipe controls under each .v6-rail: progress line + prev / next arrows.
  function init(rail) {
    if (rail.__v6nav || rail.children.length < 2) return;
    var items = rail.children, nav = document.createElement('div');
    nav.className = 'v6-railnav';
    nav.innerHTML = '<span class="v6-railnav__track" aria-hidden="true"><i class="v6-railnav__bar"></i></span>';
    var prev = button('-1', 'Previous'), next = button('1', 'Next');
    nav.appendChild(prev);
    nav.appendChild(next);
    rail.parentNode.insertBefore(nav, rail.nextSibling);
    rail.__v6nav = nav;
    var bar = nav.querySelector('.v6-railnav__bar');
    function step() { return items[1].offsetLeft - items[0].offsetLeft; }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft;
      nav.classList.toggle('is-static', max <= 2);
      if (max <= 2) return;
      bar.style.width = (rail.clientWidth / rail.scrollWidth * 100) + '%';
      bar.style.transform = 'translateX(' + (x / rail.clientWidth * 100) + '%)';
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v6-step]');
      if (!b) return;
      // Step one card; a stop within half a card of the end goes straight to the end.
      var s = step(), max = rail.scrollWidth - rail.clientWidth;
      var left = (Math.round(rail.scrollLeft / s) + parseInt(b.getAttribute('data-v6-step'), 10)) * s;
      if (left > max - s / 2) left = max;
      rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  // Mobile anatomy: the selected detail opens inside its own row, so the change shows where the tap was.
  var narrow = window.matchMedia('(max-width: 798px)');
  function initAnat(root) {
    if (root.__v6inline) return;
    root.__v6inline = true;
    root.querySelectorAll('[data-v6-row]').forEach(function (row) {
      var src = root.querySelector('img[data-v6-img="' + row.getAttribute('data-v6-row') + '"]');
      if (!src) return;
      var img = src.cloneNode();
      img.removeAttribute('class');
      img.removeAttribute('data-v6-img');
      img.alt = '';
      img.loading = 'lazy';
      var box = document.createElement('span');
      box.className = 'v6-anat__inline';
      box.appendChild(img);
      row.appendChild(box);
    });
    // A row above may collapse as this one opens; keep the tapped row where the finger left it.
    var held = null;
    root.addEventListener('click', function (e) {
      var row = narrow.matches && e.target.closest('[data-v6-row]');
      held = row ? { row: row, top: row.getBoundingClientRect().top } : null;
    }, true);
    root.addEventListener('click', function () {
      if (!held) return;
      var shift = held.row.getBoundingClientRect().top - held.top;
      if (Math.abs(shift) > 1) window.scrollBy(0, shift);
      held = null;
    });
  }
  // The hero fills the first screen below the header (capped in CSS), so its actions stay above the fold.
  function fitHero() {
    document.querySelectorAll('.v6-hero').forEach(function (hero) {
      hero.style.setProperty('--v6-top', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px');
    });
  }
  function scan(root) {
    root.querySelectorAll('.v6-rail').forEach(init);
    root.querySelectorAll('[data-v6-anat]').forEach(initAnat);
    fitHero();
  }
  window.addEventListener('resize', fitHero);
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
